import { ref, nextTick } from 'vue'

/** 链对调：上下交叉一次 → 中点换数据 → 瞬时落位（不再回弹第二段） */
export const CHAIN_FLIP_MS = 520
const SWAP_AT_MS = 260

export function useChainFlipAnimation() {
  const chainFlipping = ref(false)
  const flipPhasePass = ref(false)
  const flipSpinHalf = ref(false)

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

  /**
   * @param {() => void | Promise<void>} swapFn 在中点执行链状态对调
   * @returns {Promise<boolean>} 是否完成动画（被防抖拦截时为 false）
   */
  async function withChainFlip(swapFn) {
    if (chainFlipping.value) return false
    chainFlipping.value = true
    flipPhasePass.value = true
    flipSpinHalf.value = !flipSpinHalf.value

    await sleep(SWAP_AT_MS)
    await swapFn()
    await sleep(CHAIN_FLIP_MS - SWAP_AT_MS)

    flipPhasePass.value = false
    await nextTick()
    chainFlipping.value = false
    return true
  }

  return { chainFlipping, flipPhasePass, flipSpinHalf, withChainFlip, CHAIN_FLIP_MS }
}
